import { appConstants } from "../_constants";
import { initialState } from "../_store";

export function landingDisplay(state = initialState.landingDisplay, action) {
  
  switch (action.type) {
    case appConstants.LANDING_DISPLAY:
      return action.display;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/landing-display.js